import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import img1 from "./assets/img1.png";
import img2 from "./assets/img2.png";
import img3 from "./assets/img3.png";
import img4 from "./assets/img4.png";
import img5 from "./assets/img5.png";
import img6 from "./assets/img6.png";

const images = [
  { id: "img-1", src: img1 },
  { id: "img-2", src: img2 },
  { id: "img-3", src: img3 },
  { id: "img-4", src: img4 },
  { id: "img-5", src: img5 },
  { id: "img-6", src: img6 },
];

const HomeAbout = () => {
  return (
    <section className="w-full bg-white font-epilogue py-20 px-6 md:px-16">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-14">

        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="w-full md:w-[45%]"
        >
          <Link to="/about">
            <button className="bg-[#EAF1FF] text-[#004BA8] text-sm font-semibold px-4 py-2 rounded-full mb-4 shadow-sm">
              About us
            </button>
          </Link>

          <h1 className="text-black font-bold mb-6 text-[clamp(22px,3vw,36px)] leading-snug">
            JIVIEWS Solutions is a <br className="hidden md:block" />
            technology-driven company
          </h1>

          <p className="text-[#5C5C5C] text-[16px] leading-relaxed max-w-[500px]">
            We provide innovative software solutions that streamline processes,
            enhance productivity, and empower organizations to make smarter,
            data-driven decisions.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
          className="flex w-full md:w-[55%] justify-center gap-5 flex-wrap md:flex-nowrap"
        >
          {images.map((item, index) => {
            let sizeClass = "";

            if (index === 0 || index === 5)
              sizeClass = "w-[70px] md:w-[95px] h-[300px] md:h-[340px]";
            else if (index === 1 || index === 4)
              sizeClass = "w-[85px] md:w-[110px] h-[320px] md:h-[380px]";
            else
              sizeClass = "w-[95px] md:w-[125px] h-[360px] md:h-[400px]";

            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                viewport={{ once: true }}
                whileHover={{ y: -8, scale: 1.05 }}
                className="overflow-hidden"
              >
                <img
                  src={item.src}
                  alt={`Visual ${index + 1}`}
                  className={`${sizeClass} object-cover transition-transform duration-500`}
                />
              </motion.div>
            );
          })}
        </motion.div>

      </div>
    </section>
  );
};

export default HomeAbout;
